module.exports = __webpack_public_path__ + "static/media/spence-purple.806ad495.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spence-purple.svg
// module id = 2441
// module chunks = 0